require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./kriterien-schliesstage-geschl-jahr-0-3-j.json") })
        }
      }, "path---kriterien-schliesstage-geschl-jahr-0-3-j");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---kriterien-schliesstage-geschl-jahr-0-3-j!./.cache/json/kriterien-schliesstage-geschl-jahr-0-3-j.json
// module id = 1085
// module chunks = 231608221292675